/* ==========================================================================
   VICTORY PATH — vp-cart.js
   Ajax cart drawer using the Shopify Cart API (fetch, no jQuery).
   ========================================================================== */
(function () {
  'use strict';

  window.VP = window.VP || {};

  // Read routes lazily — they are defined in an inline script AFTER this file.
  function R() { return (window.VP && window.VP.routes) || {}; }

  var drawer, overlay, itemsEl, subtotalEl, countEls;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function openDrawer() {
    document.body.classList.add('cart-open');
    document.body.style.overflow = 'hidden';
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer() {
    document.body.classList.remove('cart-open');
    document.body.style.overflow = '';
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }

  function money(cents) { return VP.formatMoney(cents); }

  function lineHTML(item) {
    var img = item.image
      ? '<img class="cart-line__img" src="' + item.image.replace(/(\.[^.]*)$/, '_160x$1') + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
      : '<span class="cart-line__img"></span>';
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="cart-line__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
    return '' +
      '<div class="cart-line" data-key="' + item.key + '">' +
        '<a href="' + item.url + '">' + img + '</a>' +
        '<div>' +
          '<a href="' + item.url + '" class="cart-line__title">' + escapeHtml(item.product_title) + '</a>' +
          variant +
          '<div class="cart-line__qty" data-line-qty>' +
            '<button type="button" data-line-change="-1" aria-label="Weniger">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-line-change="1" aria-label="Mehr">+</button>' +
          '</div>' +
          '<button type="button" class="cart-line__remove" data-line-remove>Entfernen</button>' +
        '</div>' +
        '<div class="cart-line__price">' + money(item.final_line_price) + '</div>' +
      '</div>';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render(cart) {
    if (countEls) countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">' + (VP.strings ? VP.strings.cartEmpty : 'Dein Warenkorb ist leer.') + '</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(lineHTML).join('');
    }
    if (subtotalEl) subtotalEl.innerHTML = money(cart.total_price);
    var foot = document.querySelector('[data-cart-foot]');
    if (foot) foot.hidden = cart.item_count === 0;
  }

  function fetchCart() {
    return fetch(R().cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addToCart(formData) {
    return fetch(R().cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    }).then(function (r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    return fetch(R().cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  ready(function () {
    drawer = document.querySelector('[data-cart-drawer]');
    overlay = document.querySelector('[data-cart-overlay]');
    itemsEl = document.querySelector('[data-cart-items]');
    subtotalEl = document.querySelector('[data-cart-subtotal]');
    countEls = Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]'));

    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(render).then(openDrawer);
      });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    document.querySelectorAll('form[action$="/cart/add"], [data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-atc]');
        if (btn) { btn.disabled = true; btn.dataset.prevText = btn.textContent; btn.textContent = '…'; }
        addToCart(new FormData(form)).then(function (res) {
          if (res.status) {
            if (btn) { btn.disabled = false; btn.textContent = btn.dataset.prevText; }
            return;
          }
          return fetchCart().then(function (cart) {
            render(cart);
            openDrawer();
            if (btn) { btn.disabled = false; btn.textContent = btn.dataset.prevText; }
          });
        }).catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.prevText; }
        });
      });
    });

    if (itemsEl) {
      itemsEl.addEventListener('click', function (e) {
        var line = e.target.closest('.cart-line');
        if (!line) return;
        var key = line.getAttribute('data-key');
        var changeBtn = e.target.closest('[data-line-change]');
        var removeBtn = e.target.closest('[data-line-remove]');
        if (changeBtn) {
          var dir = parseInt(changeBtn.getAttribute('data-line-change'), 10);
          var current = parseInt(line.querySelector('.cart-line__qty span').textContent, 10) || 1;
          changeLine(key, Math.max(0, current + dir)).then(render);
        } else if (removeBtn) {
          changeLine(key, 0).then(render);
        }
      });
    }
  });
})();
